export default "__VITE_ASSET__G2N3su5g__"